import React from "react";

const SeniorSvg = () => (
  <svg
    viewBox="0 0 150 107"
    css={`
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
    `}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M119.063 6.387L96.916 22.004 74.748 6.387 52.602 22.004 30.432 6.387 8.288 22.004v79.483h132.944V22.004L119.063 6.387z"
      fill="#EB9C46"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M143.817 29.868l-2.585-1.814v-6.05L119.063 6.387 96.916 22.004 74.748 6.387 52.602 22.004 30.432 6.387 8.288 22.004v6.078l-2.533 1.782L0 21.686 30.434.272 52.6 15.887 74.746.27l22.169 15.617L119.056.274l30.506 21.408-5.745 8.186z"
      fill="#E6832D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M96.917 28.121L74.749 12.504 52.604 28.121 30.43 12.502 8.288 28.082v-6.078L30.432 6.387l22.17 15.617L74.748 6.387l22.168 15.617 22.147-15.617 22.169 15.617v6.05L119.069 12.5 96.917 28.121z"
      fill="#D7542B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M75.991 60.507a11.408 11.408 0 0 0-1.233-.066l-.179.001a19.853 19.853 0 0 1-2.918-10.393c0-11.006 8.925-19.934 19.936-19.934 7.299 0 13.684 3.923 17.159 9.773a29.078 29.078 0 0 0-4.98-.428c-13.228 0-24.38 8.903-27.785 21.047zM103.776 97.17a28.728 28.728 0 0 1-17.753-6.107V71.705c0-.892-.103-1.761-.3-2.594a19.92 19.92 0 0 0 5.874.88c11.012 0 19.942-8.926 19.942-19.942 0-3.71-1.015-7.185-2.783-10.161 13.566 2.359 23.879 14.184 23.879 28.426 0 4.07-.842 7.942-2.362 11.453v-8.062c0-6.221-5.043-11.264-11.265-11.264-6.219 0-11.263 5.043-11.263 11.264V96.9a29.18 29.18 0 0 1-3.969.27z"
      fill="#E0752B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M91.597 69.991a19.92 19.92 0 0 1-5.874-.88c-1.08-4.582-4.958-8.084-9.732-8.604 3.405-12.144 14.557-21.047 27.785-21.047 1.699 0 3.362.147 4.98.428a19.832 19.832 0 0 1 2.783 10.161c0 11.016-8.93 19.942-19.942 19.942z"
      fill="#D85B2B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M41.559 96.457V71.705c0-6.221-5.043-11.264-11.266-11.264-6.219 0-11.263 5.043-11.263 11.264v18.846a24.207 24.207 0 0 1-7.616-17.659c0-13.411 10.87-24.276 24.275-24.276 13.412 0 24.281 10.865 24.281 24.276 0 11.388-7.836 20.941-18.411 23.565z"
      fill="#E0752B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.03 106.94h22.529v-5.453H19.03v5.453z"
      fill="#E6832D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M41.559 101.487H19.03V90.551a24.188 24.188 0 0 0 16.659 6.619c2.024 0 3.991-.247 5.87-.713v5.03z"
      fill="#D7542B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.689 97.17a24.188 24.188 0 0 1-16.659-6.619V71.705c0-6.221 5.044-11.264 11.263-11.264 6.223 0 11.266 5.043 11.266 11.264v24.752a24.364 24.364 0 0 1-5.87.713z"
      fill="#D1432B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.928 71.54a5.633 5.633 0 0 1-5.634 5.634 5.633 5.633 0 1 1 5.634-5.634z"
      fill="#D6EDED"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M63.495 106.94h22.528v-5.453H63.495v5.453z"
      fill="#E6832D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M86.023 101.487H63.495V71.705c0-6.161 4.948-11.167 11.084-11.263.323.53.671 1.042 1.041 1.538a28.977 28.977 0 0 0-.697 6.334c0 9.243 4.344 17.469 11.1 22.749v10.424z"
      fill="#D7542B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M75.62 61.98a19.84 19.84 0 0 1-1.041-1.538l.179-.001c.417 0 .828.022 1.233.066-.136.486-.26.977-.371 1.473zM86.023 91.063c-6.756-5.28-11.1-13.506-11.1-22.749 0-2.177.241-4.296.697-6.334a19.972 19.972 0 0 0 10.103 7.131c.197.833.3 1.702.3 2.594v19.358z"
      fill="#D1432B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M85.723 69.111A19.972 19.972 0 0 1 75.62 61.98c.111-.496.235-.987.371-1.473 4.774.52 8.652 4.022 9.732 8.604z"
      fill="#CB382B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M80.394 71.54a5.633 5.633 0 0 1-5.634 5.634 5.633 5.633 0 1 1 0-11.267 5.634 5.634 0 0 1 5.634 5.633z"
      fill="#D6EDED"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M107.745 106.94h22.528v-5.453h-22.528v5.453z"
      fill="#E6832D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M130.273 101.487h-22.528V96.9c10.141-1.394 18.599-8.054 22.528-17.133v21.72z"
      fill="#D7542B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M107.745 96.9V71.705c0-6.221 5.044-11.264 11.263-11.264 6.222 0 11.265 5.043 11.265 11.264v8.062c-3.929 9.079-12.387 15.739-22.528 17.133z"
      fill="#D1432B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M124.644 71.54a5.633 5.633 0 0 1-5.634 5.634 5.633 5.633 0 1 1 0-11.267 5.634 5.634 0 0 1 5.634 5.633zM28.239 48.303a5.634 5.634 0 1 1-11.268 0 5.634 5.634 0 0 1 11.268 0zM72.705 48.303a5.634 5.634 0 1 1-11.268 0 5.634 5.634 0 0 1 11.268 0zM116.955 48.303a5.634 5.634 0 1 1-11.269 0 5.634 5.634 0 0 1 11.269 0zM28.239 33.774a5.634 5.634 0 1 1-11.268 0 5.634 5.634 0 0 1 11.268 0zM72.705 33.774a5.634 5.634 0 1 1-11.268 0 5.634 5.634 0 0 1 11.268 0zM116.955 33.774a5.634 5.634 0 1 1-11.269 0 5.634 5.634 0 0 1 11.269 0zM43.42 48.303a5.634 5.634 0 1 1-11.268 0 5.634 5.634 0 0 1 11.268 0zM87.885 48.303a5.634 5.634 0 1 1-11.268 0 5.634 5.634 0 0 1 11.268 0zM132.135 48.303a5.634 5.634 0 1 1-11.268 0 5.634 5.634 0 0 1 11.268 0zM43.42 33.774a5.634 5.634 0 1 1-11.268 0 5.634 5.634 0 0 1 11.268 0zM87.885 33.774a5.634 5.634 0 1 1-11.268 0 5.634 5.634 0 0 1 11.268 0zM132.135 33.774a5.634 5.634 0 1 1-11.268 0 5.634 5.634 0 0 1 11.268 0z"
      fill="#D6EDED"
    />
  </svg>
);

export default SeniorSvg;
